import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { log } from "@/lib/log";

/**
 * Fetches the current company's branding (logo + colors) and applies the
 * colors as CSS variables on <html>. Returns `{ logo, name }` for direct
 * use in the sidebar or PDF preview.
 */
export function useCompanyBranding(user) {
  const [company, setCompany] = useState(null);

  useEffect(() => {
    if (!user) return;
    (async () => {
      try {
        const { data } = await api.get("/company");
        if (!data) return;
        setCompany(data);
        const root = document.documentElement;
        if (data.primary_color) root.style.setProperty("--brand-primary", data.primary_color);
        if (data.accent_color) root.style.setProperty("--brand-accent", data.accent_color);
      } catch (err) {
        // Employees on some plans may not have company read access — silent fallback keeps the default theme.
        log.warn("Company branding fetch failed:", err?.message || err);
      }
    })();
  }, [user]);

  return { logo: company?.logo_data_url || "", name: company?.name || "CHECKMATE" };
}
